module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(12).0c8d98b2.png";